import { ShoppingBag } from 'lucide-react';
import { SHOP_URL } from '../../lib/constants';

export const ShopEdgeTab = () => {
  return (
    <a
      href={SHOP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="hidden lg:flex fixed top-1/2 right-0 -translate-y-1/2 z-40 bg-slate-900 text-white flex-col items-center gap-2 py-4 px-2.5 rounded-l-lg hover:px-3.5 transition-all"
      data-testid="shop-edge-tab"
      aria-label="Shop online"
    >
      <ShoppingBag className="w-4 h-4 text-cyan-400" />
      <span className="text-xs tracking-wide" style={{ writingMode: 'vertical-rl' }}>
        Shop online
      </span>
    </a>
  );
};
